import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-trust-api-key-modal',
  templateUrl: './trust-api-key-modal.component.pug',
  styleUrls: ['./trust-api-key-modal.component.scss'],
  standalone: false
})
export class TrustApiKeyModalComponent {
  @Input() apiKey = '';
  @Input() keyExist = false;
  @Output() deleteClick: EventEmitter<any> = new EventEmitter();
  @Output() saveClick: EventEmitter<any> = new EventEmitter();
  acceptedAgreement = false;
  isChanged = false;
  url = environment.TRUST_MARKETPLACE_URL;

  constructor(
    public bsModalRef: BsModalRef,
  ) { }

  save(){
    this.saveClick.emit({'xrefApiKey':this.apiKey});
    this.bsModalRef.hide();
  }
  cancel(){
    this.bsModalRef.hide();
  }
  goToTrustConsole(){
    window.open(this.url);
  }
}
